import React from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import SkeletonCustom from './SkeletonCustom';

const OuterWrapper = styled.div`
padding: 24px;
border-radius: 10px;
background-color: #e9e9e9;
.ant-col-8 {
  align-content: center;
}
.skeleton-box{
  background-color: #424b5017;
  margin: 0px;
}
`

const StrategicHighlightsSkeleton = function StrategicHighlightsSkeleton() {
  return (
    <>
      <Row className="pills-one-liner highlight-skeleton">
        <Col span={24}>
          {/* Outer container skeleton */}
          <OuterWrapper className="strategic-highlight-skeleton-wrapper">

            <Row gutter={16}>

              {/* Left Content */}
              <Col span={8}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <SkeletonCustom height="24px" width="100%" />
                  <SkeletonCustom height="16px" width="80%" />
                  <SkeletonCustom height="16px" width="20%" />
                </div>
              </Col>

              {/* Right Cards */}
              <Col span={16}>
                <Row gutter={16}>
                  {[1, 2, 3, 4].map((item) => (
                    <Col span={6} key={item}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <SkeletonCustom height="100px" width="100%" />
                      </div>
                    </Col>
                  ))}
                </Row>
              </Col>

            </Row>

          </OuterWrapper>
        </Col>
      </Row>
    </>
  );
};

export default StrategicHighlightsSkeleton;
